import $ from 'jquery';
import Swiper from 'swiper';

const imageScale = 0.68;

export default class SliderAccordion {
	constructor(options) {
		this.selector = options.selector;
		this.responsiveImages = options.responsiveImages;
		this.$section = $(this.selector);
		if (this.responsiveImages) {
			this.$images = this.$section.find(`${this.selector}__img`);
			this.$images.each(function () {
				const $image = $(this);
				// сохраняем вычисленный размер изображений на мобильных
				$image.data('mobile-width', $image.attr('width') * imageScale);
				$image.data('mobile-height', $image.attr('height') * imageScale);
			});
		}
		this.windwoWidth = $(window).width();
	}

	setMobileImageSize = () => {
		const width = $(window).width();

		this.$images.each(function () {
			const $image = $(this);
			if (width <= 767) {
				$image.css({
					width: $image.data('mobile-width'),
					height: $image.data('mobile-height')
				});
			}
			else {
				$image.css({
					width: $image.attr('width'),
					height: $image.attr('height')
				});
			}
		});
	}

	init() {
		const {selector, responsiveImages} = this;

		const settings = {
			slidesOffsetBefore: 0,
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: `${this.selector}__button-controls_next`,
				prevEl: `${this.selector}__button-controls_prev`
			}
		};

		if (responsiveImages) {
			this.setMobileImageSize();
		}

		return new Swiper(`${selector}__slider`, {
			breakpoints: {
				// tablet
				1239: settings,
				// desktop
				9999: {
					...settings,
					noSwiping: true,
					noSwipingClass: 'no-swiping'
				}
			}
		});
	}

	makeSlider() {
		if ($(this.selector).length) {
			let sliderAccordion = this.init();

			window.addEventListener('resize', () => {
				if (this.windwoWidth === $(window).width()) {
					return;
				} // handle mobile browsers viewport changes

				if (!sliderAccordion.destroyed) {
					if (Array.isArray(sliderAccordion)) {
						sliderAccordion.forEach(instance => {
							instance.destroy();
						});
					}
					else {
						sliderAccordion.destroy();
					}
				}

				this.windwoWidth = $(window).width();
				sliderAccordion = this.init();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./app/scripts/SliderAccordion.js